import { Controller } from 'stimulus';
import { FloatingMenu } from 'utils/floating_menu';

export default class DropdownController extends Controller {
  connect() {
    this.hidden = true;
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    // Opens the menu in the top layer so it isn't clipped by (or doesn't add a
    // scrollbar to) a scrolling container or modal it lives in.
    this.floatingMenu = new FloatingMenu({
      menu: this.menuTarget,
      anchor: this.element,
      placement: this.placementValue,
      matchWidth: true
    });
  }

  disconnect() {
    this.removeOutsideClickListener();
    this.floatingMenu.disconnect();
  }

  close() {
    this.hidden = true;
    this.hideMenu();
    this.removeOutsideClickListener();
  }

  toggle(e) {
    this.hidden = !this.hidden;
    if (this.hidden) {
      this.hideMenu();
      this.removeOutsideClickListener();
    } else {
      this.showMenu();
      this.addOutsideClickListener();
    }
  }

  showMenu() {
    this.menuTarget.classList.remove("hidden");
    this.floatingMenu.open();
    window.requestAnimationFrame(() => {
      this.transition({
        element: this.menuTarget,
        from: ["scale-50", "opacity-0"],
        to: ["scale-100", "opacity-100"]
      });
    });
  }

  hide(e) {
    this.hidden = true;
    this.hideMenu();
    this.removeOutsideClickListener();
  }

  hideMenu() {
    this.transition({
      element: this.menuTarget,
      from: ["scale-100", "opacity-100"],
      to: ["scale-50", "opacity-0"],
      hideAfter: 300,
      afterHide: () => { if (this.hidden) this.floatingMenu.close(); }
    });
  }

  addOutsideClickListener() {
    if (this.outsideClickListening) return;
    this.outsideClickListening = true;
    document.addEventListener('click', this.handleDocumentClick);
  }

  removeOutsideClickListener() {
    if (!this.outsideClickListening) return;
    this.outsideClickListening = false;
    document.removeEventListener('click', this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    if (event.target.shadowRoot) return; // We're clicking somewhere inside a hosted shadow root that the document
                                         // can't see, let this go by.
    if (this.hidden) return;
    if (this.element.contains(event.target)) return;
    this.close();
  }

  transition({ element, from, to, hideAfter, afterHide }) {
    element.classList.remove(...from);
    element.classList.add(...to);
    if (hideAfter) {
      setTimeout(() => {
        element.classList.add("hidden");
        if (afterHide) afterHide();
      }, hideAfter);
    }
  }
}

DropdownController.targets = ['menu'];
DropdownController.values = { placement: { type: String, default: 'left' } };
